import { render, staticRenderFns } from "./UserManager.vue?vue&type=template&id=5825c11e&scoped=true"
import script from "./UserManager.vue?vue&type=script&lang=js"
export * from "./UserManager.vue?vue&type=script&lang=js"
import style0 from "./UserManager.vue?vue&type=style&index=0&id=5825c11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5825c11e",
  null
  
)

export default component.exports